import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const PasswordInput = ({
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  id,
  name,
}) => {
  const [hidden, setHidden] = useState(true);

  return (
    <div className="password-input-wrapper">
      <input
        value={value}
        id={id}
        name={name}
        type={hidden ? "password" : "text"}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        onChange={onChange}
        style={{ width: "100%", paddingRight: "45px" }}
      />
      <FontAwesomeIcon
        className="password-toggle-icon"
        onClick={() => setHidden((prev) => !prev)}
        icon={hidden ? faEyeSlash : faEye}
        size="1x"
      />
    </div>
  );
};

export default PasswordInput;
